import { Paper, Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorState = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        textAlign: 'center',
        borderRadius: 2,
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <ErrorOutlineIcon sx={{ fontSize: 48, color: 'error.main' }} />
        <Typography variant="body1" color="error.main">
          ERROR. PLEASE TRY AGAIN LATER.
        </Typography>
      </Box>
    </Paper>
  );
};

export default ErrorState;
